import api from '../lib/axios';
import type { ApiResponse } from '@maios/shared';

export interface RequirementAssignee {
  id: string;
  email: string;
  name: string;
  avatarUrl: string | null;
}

export interface RequirementListItem {
  id: string;
  reqId: string;
  title: string;
  description: string | null;
  status: string;
  category: string;
  priority: string;
  parentId: string | null;
  assigneeId: string | null;
  dynamicFields: Record<string, any> | null;
  version: number;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
  assignee: RequirementAssignee | null;
  children: RequirementListItem[];
  _count: { specifications: number; linkedIssues: number; children: number };
}

export interface CreateRequirementData {
  title: string;
  description?: string;
  category?: string;
  priority?: string;
  parentId?: string;
  status?: string;
  assigneeId?: string;
}

export interface UpdateRequirementData {
  title?: string;
  description?: string | null;
  category?: string;
  priority?: string;
  parentId?: string | null;
  status?: string;
  assigneeId?: string | null;
  sortOrder?: number;
  changeNote?: string;
  dynamicFields?: Record<string, any>;
}

// --- 트리 구조 (CHG-029 / REQ-V29-001) ---
export interface RequirementTreeNode {
  requirementId: string;
  requirementKey: string;
  title: string;
  category: string;
  status: string;
  depth: number;
  children: RequirementTreeNode[];
}

export async function fetchRequirementTree(projectId: string) {
  const res = await api.get<ApiResponse<RequirementTreeNode[]>>(
    `/projects/${projectId}/requirements/tree`,
  );
  return res.data.data!;
}

export async function fetchRequirements(projectId: string) {
  const res = await api.get<ApiResponse<RequirementListItem[]>>(
    `/projects/${projectId}/requirements?parentId=`,
  );
  return res.data.data!;
}

export async function fetchAllRequirements(projectId: string) {
  const res = await api.get<ApiResponse<RequirementListItem[]>>(
    `/projects/${projectId}/requirements`,
  );
  return res.data.data!;
}

export async function fetchRequirement(projectId: string, reqId: string) {
  const res = await api.get<ApiResponse<RequirementListItem>>(
    `/projects/${projectId}/requirements/${reqId}`,
  );
  return res.data.data!;
}

export async function createRequirement(projectId: string, data: CreateRequirementData) {
  const res = await api.post<ApiResponse<RequirementListItem>>(
    `/projects/${projectId}/requirements`,
    data,
  );
  return res.data.data!;
}

export async function updateRequirement(projectId: string, reqId: string, data: UpdateRequirementData) {
  const res = await api.put<ApiResponse<RequirementListItem>>(
    `/projects/${projectId}/requirements/${reqId}`,
    data,
  );
  return res.data.data!;
}

export async function deleteRequirement(projectId: string, reqId: string) {
  await api.delete(`/projects/${projectId}/requirements/${reqId}`);
}
